<template>
  <div>
    <h1 class="login__title">
      {{ $t('auth.title') }}
    </h1>

    <p class="login__welcome">
      {{ $t('auth.welcome') }}
    </p>

    <v-form ref="form" @submit.prevent="validate" lazy-validation>
      <v-text-field
        v-model="username"
        :rules="[rules.required]"
        :label="$t('auth.username')"
        class="mb-5"
        autocomplete="username"
        hide-details="auto"
        name="username"
        id="username"
        type="text"
        outlined
        required
      />
      <v-text-field
        @click:append="showPass = !showPass"
        v-model="password"
        :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
        :rules="[rules.required]"
        :type="showPass ? 'text' : 'password'"
        :label="$t('auth.password')"
        class="mb-5"
        autocomplete="new-password"
        name="password"
        hide-details="auto"
        id="password"
        outlined
        required
      />

      <v-row no-gutters>
        <v-col>
          <v-btn
            @click="$router.push('/recover-password')"
            color="primary"
            depressed
            large
            text
          >
            <span class="text-body-1 font-weight-medium">
              {{ $t('auth.forgotPassword') }}
            </span>
          </v-btn>
        </v-col>
        <v-col>
          <div class="text-right">
            <v-btn
              type="submit"
              color="primary"
              :loading="isLoading"
              :disabled="isLoading"
              depressed
              large
            >
              <span class="text-body-1 font-weight-medium">
                {{ $t('auth.login') }}
              </span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { required } from '@/util/errorHandling'
import { login } from '@/services/auth/login'

export default {
  name: 'LoginForm',

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapMutations(['setIsLoading']),

    validate() {
      if (this.$refs.form.validate()) {
        this.setIsLoading(true)

        login({
          username: this.username,
          password: this.password,
        })
      }
    },
  },

  data() {
    return {
      showPass: false,
      username: '',
      password: '',
      rules: {
        required,
      },
    }
  }
}
</script>
